var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._t("default",function(){return [_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/images/logo-nph.png"),"alt":"Logo"}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }